import { AppRouteRecordRaw } from '@/router/types'

export const settingCenter: AppRouteRecordRaw[] = [
  {
    path: 'applyManage',
    name: 'ApplyManage',
    component: () => import('@/views/settingCenter/applyManage/index.vue'),
    meta: {
      title: '应用管理'
    },
    children: [
      {
        path: 'customApplication',
        name: 'CustomApplication',
        component: () => import('@/views/settingCenter/applyManage/customApplication/index.vue'),
        meta: {
          title: '自定义应用'
        },
        children: []
      },
      {
        path: 'predefinedApplication',
        name: 'PredefinedApplication',
        component: () =>
          import('@/views/settingCenter/applyManage/predefinedApplication/index.vue'),
        meta: {
          title: '预定义应用'
        },
        children: []
      },
      {
        path: 'fixedApplication',
        name: 'FixedApplication',
        component: () => import('@/views/settingCenter/applyManage/fixedApplication/index.vue'),
        meta: {
          title: '固定型应用'
        },
        children: []
      }
    ]
  },
  {
    path: 'flowManage',
    name: 'FlowManage',
    component: () => import('@/views/settingCenter/flowManage/index.vue'),
    meta: {
      title: '流程管理'
    },
    children: [
      {
        path: 'approveFlow',
        name: 'ApproveFlow',
        component: () => import('@/views/settingCenter/flowManage/approveFlow/index.vue'),
        meta: {
          title: '审批流程'
        },
        children: []
      },
      {
        path: 'businessFlow',
        name: 'BusinessFlow',
        component: () => import('@/views/settingCenter/flowManage/businessFlow/index.vue'),
        meta: {
          title: '业务流程'
        },
        children: []
      }
    ]
  },
  {
    path: 'systemConfig',
    name: 'SystemConfig',
    component: () => import('@/views/settingCenter/systemConfig/index.vue'),
    meta: {
      title: '系统配置'
    },
    children: [
      {
        path: 'menuConfig',
        name: 'MenuConfig',
        component: () => import('@/views/settingCenter/systemConfig/menuConfig/index.vue'),
        meta: {
          title: '菜单配置'
        },
        children: []
      }
    ]
  }
]
